import React, { useEffect } from 'react';
import PropTypes from 'prop-types';

import Select from '../../shared/reactSelect/select.component';
import { selectConnection, fetchConnections } from './store/actions';
import { connectionNameSelector, connectionNamesSelector } from './store/selectors';
import { connect } from 'react-redux';

import {
  periodOrCurrentSelector,
} from '../../shared/store/selectors';

import { OptionsPropType } from '../../shared/propTypes/common';

import { PeriodPropTypes } from '../../shared/propTypes/period';

const ConnectionDropdown = ({
  period,
  connectionName,
  connectionNames,
  selectConnection,
  fetchConnections,
}) => {
  useEffect(() => {
    fetchConnections(period.name);
  }, [period.name, fetchConnections]);

  function handleChange(connection) {
    if (connection) {
      selectConnection(connection.value);
    }
  }
  return (
    <Select
      className="select-connection"
      clearable={false}
      name="connectionName"
      options={connectionNames}
      onChange={handleChange} // eslint-disable-line react/jsx-no-bind
      scrollMenuIntoView={false}
      value={connectionName}
      placeholder="Select a Connection"
      virtualized
    />
  );
};

ConnectionDropdown.propTypes = {
  period: PeriodPropTypes.isRequired,
  connectionName: PropTypes.string,
  connectionNames: OptionsPropType,
  selectConnection: PropTypes.func.isRequired,
  fetchConnections: PropTypes.func.isRequired,
};

export default connect(state => ({
  connectionNames: connectionNamesSelector(state),
  connectionName: connectionNameSelector(state),
  period: periodOrCurrentSelector(state),
}), {
  selectConnection,
  fetchConnections,
})(ConnectionDropdown);
